const isProd = process.env.NODE_ENV === 'production';

export const basePath = isProd ? window.environmentalVariables.basePath : '/';

export const oidcConfig = isProd
  ? {
      authority: window.environmentalVariables.identityServerUrl,
      client_id: 'SelfServiceNew',
      redirect_uri: window.environmentalVariables.baseUrl + '/LoginCallback',
      response_type: 'id_token token',
      scope: 'openid profile SelfServiceApi',
      post_logout_redirect_uri: window.environmentalVariables.baseUrl,
    }
  : {
      authority: 'https://oc-qa-t2.debitsuccess.com/Identity',
      client_id: 'SelfServiceNew',
      redirect_uri: 'https://localhost:44308/LoginCallback',
      response_type: 'id_token token',
      scope: 'openid profile SelfServiceApi',
      post_logout_redirect_uri: 'https://localhost:44308',
    };

export const oldSelfServiceLink = isProd
  ? window.environmentalVariables.oldSelfServiceLink
  : 'https://localhost/SelfServiceOld';

export const wdeLink = isProd
  ? window.environmentalVariables.wdeLink
  : 'https://localhost/DirectEntry';

export const locale = isProd ? window.environmentalVariables.locale : 'en-NZ';
